import React, { useEffect, useState } from "react";
import db from "../../../db"

// reactstrap components
import {
    Button,
    Input,
    Media,
    Row,
    Col,
    Form,
    FormGroup,
    Card,
} from "reactstrap";
import Select from "react-select";

// core components
import ImageUpload from "../../UploadImages/ImageUpload"
import DragDrop from "../../UploadImages/DragDrop"
import { handleUpload } from "../../UploadImages/HandleUpload"

function EventCategoryForm({ selectedCategory, setSelectedCategory, flag, deleted, setDeleted }) {

    // Object Properties
    const [eventCategoryId, setEventCategoryId] = useState("")
    const [caption, setCaption] = useState("")
    const [description, setDescription] = useState("")
    const [img, setImg] = useState([])
    const [isDisplayed, setIsDisplayed] = useState("")
    const [name, setName] = useState("")

    // For Upload
    // Progress bar
    const [progress, setProgress] = useState(0)

    // Disable buttons when creating/editing
    const [disabled, setDisabled] = useState(false)

    const upload = async (taskFunction, task) => {
        const convert = { img: deleted }
        deleted.length > 0 && await db.EventCategories.removeOneImage(convert)

        let docRef = ""
        if (task === "create") {
            // If creating, create a new ID from firestore
            docRef = await db.EventCategories.createRef().id
        }
        else {
            docRef = eventCategoryId
        }
        // Change directory to where you want to save it
        const directory = `portfolio/${docRef}/${name}`
        handleUpload({ pictures: img, setProgress, docRef, taskFunction, task, directory })
    }

    const create = ({ urls, docRef }) => {
        // img: urls[0] means it will only take 1 image
        // img should be stored as a list
        db.EventCategories.update({ id: docRef, caption, description, img: urls[0], isDisplayed: true, name })
        reset()
    }

    const edit = async ({ urls }) => {
        // img: urls[0] means it will only take 1 image
        // img should be stored as a list
        db.EventCategories.update({ id: eventCategoryId, caption, description, img: urls[0], isDisplayed, name })
        reset()
    }

    const reset = () => {
        setEventCategoryId("")
        setCaption("")
        setDescription("")
        setImg([])
        setIsDisplayed("")
        setName("")
        setProgress(0)
        setSelectedCategory(null)
        setDeleted([])
        setDisabled(false)
    }

    // Set Input values to Selected Event's data
    useEffect(() => {
        if (selectedCategory) {
            setEventCategoryId(selectedCategory.id)
            setCaption(selectedCategory.caption)
            setDescription(selectedCategory.description)
            setImg([selectedCategory.img])
            setIsDisplayed(selectedCategory.isDisplayed)
            setName(selectedCategory.name)
        }
    }, [selectedCategory, flag])

    // Validation
    const valid = () =>
        img.length > 0 &&
        name.length > 0 &&
        !disabled

    const validEdit = () =>
        !valid()

    return (
        <Card className="section-dark-blue">
            <Media style={{ padding: "2%" }}>
                <Form className="form" style={{ minWidth: "100%", minHeight: "100%" }}>
                    <Media body>
                        <Row>
                            <Col md="12">
                                <FormGroup>
                                    {/* You only need this one */}
                                    <ImageUpload
                                        pictures={img}
                                        progress={progress}
                                        maxNumber={1}
                                        setPictures={setImg}
                                        deleted={deleted}
                                        setDeleted={setDeleted}
                                        disabled={disabled}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            {/* This is for drag and drop - optional */}
                            <Col md="12" >
                                {
                                    img.length === 0 &&
                                    <FormGroup>
                                        <DragDrop setPictures={setImg} />
                                    </FormGroup>
                                }
                            </Col>
                        </Row>
                        <Row>
                            <Col md="6">
                                <FormGroup>
                                    <Input
                                        className="border-input"
                                        placeholder="Caption"
                                        type="text"
                                        onChange={(event) => setCaption(`${event.target.value}`)}
                                        value={caption}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Input
                                        className="border-input"
                                        placeholder="Description"
                                        type="text"
                                        onChange={(event) => setDescription(event.target.value)}
                                        value={description}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="6">
                                <FormGroup>
                                    <Input
                                        className="border-input"
                                        placeholder="Name"
                                        type="text"
                                        onChange={(event) => setName(event.target.value)}
                                        value={name}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Select
                                        className="react-select react-select-default border-input"
                                        // classNamePrefix="react-select"
                                        name="Display?"
                                        value={isDisplayed}
                                        onChange={(value) => setIsDisplayed(value.value)}
                                        options={[{ value: true, label: "TRUE" }, { value: false, label: "FALSE" }]}
                                        placeholder={isDisplayed.toString().toLocaleUpperCase() || "Display Category?"}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <div className="media-footer">
                            <Row>
                                <Col lg="8" xs="6" md="8">
                                    {
                                        !eventCategoryId ?
                                            <Button
                                                className="btn-round mr-1"
                                                color="success"
                                                type="button"
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    upload(create, "create")
                                                    setDisabled(true)
                                                }}
                                                disabled={!valid()}
                                                style={{ minWidth: "100%" }}
                                            >
                                                Create
                                            </Button>
                                            :
                                            <Button
                                                className="btn-round mr-1"
                                                color="success"
                                                type="button"
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    upload(edit, "edit")
                                                    setDisabled(true)
                                                }}
                                                disabled={validEdit()}
                                                style={{ minWidth: "100%" }}
                                            >
                                                Edit
                                            </Button>
                                    }
                                </Col>
                                <Col lg="4" xs="6" md="4">
                                    <Button
                                        className="btn-round mr-1"
                                        color="danger"
                                        type="button"
                                        onClick={reset}
                                        style={{ minWidth: "100%" }}
                                        disabled={disabled}
                                    >
                                        Cancel
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    </Media>
                </Form>
            </Media>
        </Card>
    );
}

export default EventCategoryForm;
